import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel", "method"]

  connect() {
    const initial = this.methodTarget?.value || this.tabTargets[0]?.dataset.method
    this.activate(initial)
  }

  switch(event) {
    event.preventDefault()
    this.activate(event.currentTarget.dataset.method)
  }

  activate(method) {
    this.tabTargets.forEach((el) => {
      el.classList.toggle("active", el.dataset.method === method)
    })
    this.panelTargets.forEach((el) => {
      el.classList.toggle("active", el.dataset.method === method)
    })
    if (this.hasMethodTarget) this.methodTarget.value = method
  }
}
